import { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfUnity } from '../../database';

import api from '../../services/api';
import { useAuth } from 'src/contexts/auth';
import { AxiosResponse } from 'axios';

const initialValuesOfUnity = {
	ORGAO: '',
	NOME: '',
	EMAIL: '',
	TELEFONE: '',
	TIPOUNIDADE: 0,
};

export const useListUnitysController = () => {
	const { userAgencyId } = useAuth();
	const [UnitysData, setUnitysData] = useState<ModelOfUnity[]>([]);
	const [AllUnitysData, setAllUnitysData] = useState<ModelOfUnity[]>([]);
	const [selectedUnity, setSelectedUnity] = useState<ModelOfUnity>(initialValuesOfUnity);
	const [loading, setLoading] = useState(false);
	const [loadingRows, setLoadingRows] = useState(false);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);
	const [loadingEdit, setLoadingEdit] = useState(false);
	const [rows, setRows] = useState(0);
	const [maxData, setMaxData] = useState(false);

	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		NOME: Yup.string().required('* Campo obrigatório'),
		EMAIL: Yup.string().email('* Informe um email válido').required('* Campo obrigatório'),
		TELEFONE: Yup.string().required('* Campo obrigatório'),
	});

	const getAllUnitys = () => {
		setUnitysData([]);
		api.post('agencys/all-unitys', { ORGAO: userAgencyId })
			.then(response => {
				const data = response.data;

				console.log("   ---> ", data);

				setAllUnitysData(data);
				setUnitysData(data);
				setLoading(false);
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
			});
	};

	const getUnitys = () => {
		// Buscar novos dados
		if (rows === 0) {
			setLoading(true);
		} else {
			setLoadingRows(true);
		}
		//necessario refatorar com o ROW, enviar ROW.
		api.post('agencys/unitys2', { ORGAO: userAgencyId, ROW: rows })
			.then(response => {
				if (response.status === 204) {
					setMaxData(true);
					setLoading(false);
					setLoadingRows(false);
				} else {
					setUnitysData(rows === 0 ? response.data : UnitysData.concat(response.data));
					setLoading(false);
					setLoadingRows(false);
				}
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				// um dos erro retornado é a lista esta vazia, ou seja nao tem mais
				// significa foi buscado tudo
				setLoading(false);
				setLoadingRows(false);
			});
	};

	const removeUnity = (Unity: ModelOfUnity) => {
		setLoading(true);
		api.delete(`unitys/${Unity.ID}`)
			.then(response => {
				const newList = UnitysData.filter(unity => unity.ID !== response.data.ID);
				setUnitysData(newList);
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'A unidade foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch((err) => {
				getAllUnitys();
				setDeleteDialog(false);
				setLoading(false);
				const detail = err?.response?.data?.ERROR?.message
					|| err?.response?.data?.message
					|| err?.message
					|| 'Falha ao realizar operação!';
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail,
					life: 8000,
				});
			});
	};

	const editUnity = (Unity: ModelOfUnity) => {
		setLoadingEdit(true);

		const editedUnity: ModelOfUnity = {
			...Unity,
			ORGAO: userAgencyId,
		};

		api.put(`unitys/${selectedUnity?.ID}`, editedUnity)
			.then(() => {
				// getUnitys();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'A unidade foi editada com sucesso!',
					life: 5000,
				});
				setTimeout(() => {
					window.location.reload();
				}, 1500);
			})
			.catch(err => {
				getAllUnitys();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	useEffect(() => {
		getAllUnitys();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userAgencyId]);

	//useEffect(() => {
		//getUnitys();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	//}, [rows]);

	const openDeleteDialog = (Unity: ModelOfUnity) => {
		setDeleteDialog(true);
		setSelectedUnity(Unity);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (Unity: ModelOfUnity) => {
		setEditDialog(true);
		setSelectedUnity(Unity);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const formik = useFormik<ModelOfUnity>({
		initialValues: {
			ORGAO: '',
			NOME: '',
			EMAIL: '',
			TELEFONE: '',
			TIPOUNIDADE: 0,
		},
		onSubmit: async values => await editUnity(values),
		validationSchema,
	});

	return {
		getUnityListController: {
			formik,
			UnitysData,
			AllUnitysData,
			selectedUnity,
			loading,
			loadingRows,
			deleteDialog,
			editDialog,
			loadingEdit,
			toast,
			rows,
			maxData,
		},
		handleUnityListController: {
			removeUnity,
			editUnity,
			closeDeleteDialog,
			openDeleteDialog,
			openEditDialog,
			closeEditDialog,
			setRows,
			getAllUnitys,
		},
	};
};
